import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Controls, TableData } from '../model/model';
import { AuthService } from './auth.service';
import { errorStatus401 } from '../shared/constant';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  access_token!: string;
  result!: TableData;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
  ) {}

  private readonly httpClient = inject(HttpClient);

  callApi(filterValues: Controls): Promise<TableData> {
    return this.authService.getUser().then((user) => {
      if (user?.access_token) {
        this.access_token = user.access_token;
        return this.makeApiRequest(filterValues);
      } else if (user) {
        return this.authService.renewToken().then((user) => {
          return this.makeApiRequest(filterValues);
        });
      } else {
        console.log('callApi in DataService', 'user is not logged in');
        throw new Error('user is not logged in');
      }
    });
  }

  private async makeApiRequest(filterValues: Controls): Promise<TableData> {
    try {
      return this.getApiData(filterValues);
    } catch (error) {
      console.log('makeApiRequest in DataService', 'Error in making API request')
      throw error;
    }
  }

  async getApiData(filterValues: Controls) {

    const apiUrl = environment.API_URL;
    const apiKey = environment.apigee_apikey;

    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + this.access_token,
      'x-apikey': apiKey
    });

    return firstValueFrom(
      this.httpClient.post<TableData>(apiUrl, filterValues, { headers })
    ).catch((result: HttpErrorResponse) => {
      if (result.status === errorStatus401) {
        console.log('getApiData in DataService', 'Getting error status 401 while hitting api');
        return this.authService.renewToken().then(() => {
          return this.callApi(filterValues);
        });
      }
      throw result;
    });
  }
}
